import { MutationTree } from "vuex";
import { ISupplierState } from "./state";
import { ISupplier } from "@/models";
import { ADD_SUPLLIERS, SET_SUPPLIERS, CLEAN_SUPPLIERS } from "./mutations-types";

export const mutations: MutationTree<ISupplierState> = {
    [ADD_SUPLLIERS](state, payload: ISupplier[]): void {
        state.suppliers = state.suppliers.concat(payload);
    },

    [SET_SUPPLIERS](state, payload: ISupplier[]): void {
        state.suppliers = payload;
    },

    [CLEAN_SUPPLIERS](state): void {
        state.suppliers = [];
    },
};
